import { useParams, Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useLanguage } from '../../i18n';
import styles from './OrganizationDetail.module.css';

// Dummy data (in real app: fetch by slug)
const dummyOrgs = {
  'global-rights': {
    name: "Global Rights Foundation",
    type: "Digital Security Helpdesk",
    description: "24/7 emergency digital security support, incident response, and secure communication guidance.",
    website: "globalrights.foundation",
    phone: "+1-800-SECURE (732-873)",
    email: "help@globalrights.foundation",
    hours: "Available 24/7",
    regions: "Global",
    languages: "English, Spanish, French, Arabic"
  },
  // add more as needed
};

export default function OrganizationDetail() {
  const { t } = useLanguage();
  const { orgSlug } = useParams();
  const org = dummyOrgs[orgSlug] || { name: "Organization Not Found" };

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <Link to="/support" className={styles.backLink}>
          ← {t('supportDirectory')}
        </Link>

        <h1 className={styles.title}>{org.name}</h1>
        <p className={styles.type}>{org.type}</p>

        <div className={styles.infoCard}>
          <p>{org.description}</p>

          <div className={styles.contactGrid}>
            <div>
              <strong>{t('websiteLabel') || 'Website:'}</strong>
              <a href={`https://${org.website}`} target="_blank" rel="noopener noreferrer">
                {org.website}
              </a>
            </div>
            <div>
              <strong>{t('phoneLabel') || 'Phone:'}</strong> {org.phone}
            </div>
            <div>
              <strong>{t('emailLabel') || 'Email:'}</strong>
              <a href={`mailto:${org.email}`}>{org.email}</a>
            </div>
            <div>
              <strong>{t('availabilityLabel') || 'Availability:'}</strong> {org.hours}
            </div>
          </div>

          <button className={styles.contactBtn} onClick={() => window.location.href = `mailto:${org.email}`}>
            <Icon icon="lucide:mail" />
            {t('sendMessageNow') || 'Send Message Now'}
          </button>
        </div>
      </div>
    </main>
  );
}